// Şube ve notlar.
import React from 'react';
import { Autocomplete, Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { AccountCardForm } from '../useAccountCardForm';
import { L, SectionTitle } from './fields';

export const OtherSection: React.FC<{ f: AccountCardForm }> = ({ f }) => {
  const { t } = useTranslation('accounting');
  return (
    <>
      <SectionTitle title={t(`${L}.layout.sections.other`, 'Şube ve notlar')} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            size="small"
            options={f.branches}
            getOptionLabel={(o) => o.name}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            value={f.selectedBranch}
            disabled={!!f.lockedBranchId}
            onChange={(_, v) => f.handleBranchChange(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t(`${L}.fields.branch`)}
                placeholder={t(`${L}.placeholders.branch`)}
                helperText={t(`${L}.branchHint`)}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth size="small" multiline minRows={3} label={t(`${L}.fields.notes`)}
            value={f.accountData.notes} onChange={(e) => f.handleChange('notes', e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
};
